import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { SearchConvertersModule } from './converters/search-converters.module';
import { effects } from './effects';

@NgModule({
  imports: [EffectsModule.forFeature(effects), SearchConvertersModule],
})
export class SearchFeatureModule {}
